




















































import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryWealthRecordList, QueryWealthRecordSummary, ExportWealthRecord, ManualAdjustPlatformPv } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import constant from '@/utils/constant'
import { PlatformWealthRecordTypeFormat, PlatformWealthRecordRemarkFormat } from '@/utils/tyepconvert'
import OrderDescDialog from '@/views/order/OrderDescDialog.vue'
import { Message } from 'element-ui'

@Component({
  components: {
    VQuery,
    VTable,
    OrderDescDialog,
  },
})
export default class VideoList extends Vue {
  private queryParam: any = {
    startRow: 1,
    limit: 10,
    createTimeDaterange: [],
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private summary: any = null
  private adjustVisible = false
  private adjustSubmitting = false
  private adjustForm: any = { direction: 'INCREASE', pvYuan: 0, remark: '' }

  private queryModels: Array<QueryModel> = [
    { title: '类型', param: 'type', type: 'select', selectData: constant.PlatformWealthRecordType },
    { title: '订单号', param: 'orderNo' },
    { title: '创建时间', param: 'createTimeDaterange', type: 'daterange' },
  ]
  private queryOperation: Array<TableOperation> = [
    { title: '导出', type: 'primary', click: this.exportOrderHandle },
  ]
  private tableHander: Array<TableHander> = [
    { title: '编号', param: 'id', width: 60 },
    { title: '类型', param: 'type', formatter: PlatformWealthRecordTypeFormat, width: 60 },
    { title: '订单号', param: 'orderNo', width: 160 },
    { title: '订单产生pv', param: 'orderPv' },
    { title: '平台获得pv', param: 'platformPv' },
    { title: '代理获得pv', param: 'memberTotalPv' },
    { title: '店铺推荐人获得pv', param: 'shopInvitePv' },
    { title: '备注', param: 'remark', minWidth: 160, overflow: true, formatter: PlatformWealthRecordRemarkFormat },
    { title: '创建时间', width: 160, param: 'createTime', formatter: DateFormat },
  ]

  public activated() {
    if (this.$route.query.createTime) {
      this.queryParam.createTimeDaterange = [
        this.$route.query.createTime + ' 00:00:00',
        this.$route.query.createTime + ' 23:59:59',
      ]
    }
    this.loadAll()
  }

  private getSummaryParam() {
    const param: any = { ...this.queryParam }
    if (param.createTimeDaterange && param.createTimeDaterange.length > 0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    return param
  }

  private async loadSummary() {
    this.summary = await QueryWealthRecordSummary(this.getSummaryParam())
  }

  private openAdjustDialog() {
    this.adjustForm = { direction: 'INCREASE', pvYuan: 0, remark: '' }
    this.adjustVisible = true
  }

  private async submitAdjust() {
    if (!this.adjustForm.pvYuan || this.adjustForm.pvYuan <= 0) {
      Message.warning('请输入大于0的金额')
      return
    }
    if (!this.adjustForm.remark || !String(this.adjustForm.remark).trim()) {
      Message.warning('请填写备注')
      return
    }
    this.adjustSubmitting = true
    try {
      await ManualAdjustPlatformPv({
        direction: this.adjustForm.direction,
        pvYuan: this.adjustForm.pvYuan,
        remark: this.adjustForm.remark,
      })
      Message.success('调账成功')
      this.adjustVisible = false
      await this.loadAll()
    } finally {
      this.adjustSubmitting = false
    }
  }

  private exportOrderHandle() {
    const loading = this.$loading({
      lock: true,
      text: '正在导出平台PV流水',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })
    const param: any = this.getSummaryParam()
    param.limit = ''
    param.startRow = ''
    ExportWealthRecord(param, '平台PV流水.xlsx')
      .then(() => loading.close())
      .catch(() => loading.close())
  }

  private async loadData() {
    const param: any = { ...this.queryParam }
    if (param.createTimeDaterange && param.createTimeDaterange.length > 0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 10)
    const result = await QueryWealthRecordList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private async loadAll() {
    await Promise.all([this.loadSummary(), this.loadData()])
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadAll()
  }

  public onReset() {
    this.tableCurrntPage = 1
    this.loadAll()
  }

  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
